.empty-column-placeholder {
  min-height: 100px;
  border: 2px dashed var(--grey-300);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--grey-500);
  font-size: 14px;
}
